


export const API_URL = 'https://api-webreporting.milvendas.ao/api';